// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"d0e911e4","386":"7c708ffb","518":"cd04519d"}[chunkId] + ".chunk.js";
};